export default __webpack_public_path__ + "static/media/press-header-icon.70f71e5e.svg";